import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { UntypedFormGroup, AbstractControl } from '@angular/forms';
import { Component } from '@angular/core';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { VALIDATORS } from 'src/environments/validators';
import { RegistrationService } from 'src/app/services/registration-service/registration.service';

@Component({
    selector: 'app-password-reset-screen',
    templateUrl: './password-reset-screen.component.html',
    styleUrls: ['./password-reset-screen.component.css'],
    standalone: false
})
export class PasswordResetScreenComponent {
    passwordResetForm: UntypedFormGroup;

    email: AbstractControl;

    constructor(
        formBuilder: UntypedFormBuilder,
        private registrationService: RegistrationService,
        private router: Router,
        private dialogService: DialogService
    ) {
        this.passwordResetForm = formBuilder.group({
            email: ['', VALIDATORS.email]
        });
        this.email = this.passwordResetForm.controls['email'];
    }

    onSubmit() {
        let username = this.email.value.toLowerCase();
        this.registrationService
            .resetPassword(username)
            .then(() => {
                this.registrationService.resetLoginAttempts(username);
                this.dialogService
                    .openDialog(
                        'Passwort zurückgesetzt',
                        'Ihr Passwort wurde erfolgreich zurückgesetzt. ' +
                            'Innerhalb der nächsten Minuten sollten Sie eine E-mail mit Ihrem neuen Passwort erhalten. ' +
                            'Nach erfolgreicher Anmeldung können Sie Ihr Passwort auf Ihr gewünschtes Passwort ändern.'
                    )
                    .subscribe(() => {
                        this.dialogService.openLoginDialog().subscribe((result) => {
                        if (result === 'success') {
                            this.router.navigate(['/']);
                        }
        });
                    });
            })
            .catch(() => {});
    }

    public onCancel(): void {
        this.router.navigate(['/']);
    }
}
